import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, mergeMap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PodcastService {

  endpointApi = environment.apiCmsRetalk;
  apiCmsPosters = environment.apiCmsPosters;
  podcast: any;

  constructor(private http: HttpClient) { }

  // Handle API errors =================================
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An client error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log("Backend error code " + error.status + ", body was: " + JSON.stringify(error.error));
    }
    // return an observable with a user-facing error message
    return throwError(() => error.error)
  }

  getPodcast(id: number) {
    this.podcast = this.http.get<any>(this.endpointApi + 'find?id=' + id)
      .pipe(
        map(resp => {
          return resp.data.retalk;
        }),
        catchError(this.handleError)
      )
    return this.podcast;

  }

  getPodcastWithImages(id: number): Observable<any> {
    return this.http.get<any>(this.endpointApi + '/find?id=' + id)
      .pipe(
        mergeMap(resp => {
          const retalk = resp.data.retalk;
          return this.getImagesByPodcast(retalk.id)
            .pipe(
              map(posters => {
                retalk.images = posters;
                return retalk;
              })
            )
        }),
        catchError(this.handleError)
      )
  }

  getImagesByPodcast(id: string) {
    return this.http.get<any>(this.apiCmsPosters + '/get?fk_idRetalk=' + id)
      .pipe(
        map(resp => resp.data.posters),
        catchError(this.handleError)
      )
  }


  getPodcastPreview(id: number) {
    this.podcast = this.http.get<any>(this.endpointApi + 'find?id=' + id)
      .pipe(
        map(resp => {
          return resp.data.article;
        }),
        catchError(this.handleError)
      )
    return this.podcast;

  }


}
